import { render, staticRenderFns } from "./AccountModalRegisterRemove.vue?vue&type=template&id=5925f818&"
import script from "./AccountModalRegisterRemove.vue?vue&type=script&lang=js&"
export * from "./AccountModalRegisterRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports